import { render } from "./ParticipantSelector.vue?vue&type=template&id=12a7313f&scoped=true"
import script from "./ParticipantSelector.vue?vue&type=script&lang=js"
export * from "./ParticipantSelector.vue?vue&type=script&lang=js"

import "./ParticipantSelector.vue?vue&type=style&index=0&id=12a7313f&lang=scss&scoped=true"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a7313f"]])

export default __exports__